import { ColDef } from "ag-grid-community";
import dayjs from "dayjs";
import { date, utcDate } from "~utils/Date.ts";

/**
 * Date column type for the ag-grid.
 */
export const DateTimeColumn: ColDef = {
	filter: "agDateColumnFilter",
	floatingFilter: true,
	filterParams: {
		maxNumConditions: 10,
		filterOptions: [
			"equals",
			"notEqual",
			"lessThan",
			"lessThanOrEqual",
			"greaterThan",
			"greaterThanOrEqual",
			"inRange",
			"blank",
			"notBlank",
		],
	},
	valueFormatter(params) {
		if (params.value && params.value != "null") {
			const parsedDate = utcDate(params.value).local();
			return parsedDate.calendar();
		}

		return "-";
	},
};
